





























import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import Frontpage from '@/pdf/pages/Frontpage.vue';
import ReportBackground from '@/pdf/components/ReportBackground.vue';
import Remarks from '@/pdf/components/Remarks.vue';
import Compass from '@/components/Compass.vue';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';
import CompanyCompass from '@/pdf/pages/CompanyCompass.vue';
import CompanyProfitLoss from '@/pdf/pages/CompanyProfitLoss.vue';
import CompanyBalance from '@/pdf/pages/CompanyBalance.vue';
import CompanyFinancialRatios from '@/pdf/pages/CompanyFinancialRatios.vue';
import CompanyCashflow from '@/pdf/pages/CompanyCashflow.vue';
import CompanyValuation from '@/pdf/pages/CompanyValuation.vue';
import CompanySustainability from '@/pdf/pages/CompanySustainability.vue';
import GTSustainability from '@/pdf/pages/GTSustainability.vue';
import TableCompass from '@/pdf/pages/TableCompass.vue';
import AppendixCompass from '@/pdf/pages/AppendixCompass.vue';
import Liability from '@/pdf/pages/Liability.vue';

@Component({
  components: {
    Frontpage,
    ReportBackground,
    Remarks,
    Compass,
    SummaryOverview,
    PageFooter,
    CompanyCompass,
    CompanyProfitLoss,
    CompanyBalance,
    CompanyFinancialRatios,
    CompanyCashflow,
    CompanyValuation,
    CompanySustainability,
    GTSustainability,
    TableCompass,
    AppendixCompass,
    Liability},
})
export default class Sandbox extends Report {
  async mounted() {
    await this.loadDocument();
  }
}
